import React from 'react'
import {createUseStyles} from 'react-jss'
import {Colors} from "../../../constants/colors"
import {UpcomingPayroll} from "../../../redux/types"
import Card from '../../Card'
import {
  DueContent,
  FutureContent,
  OverdueContent,
  StatusIcon,
  SuccessContent,
  UpcomingContent,
  ValidationErrorContent
} from './components'

interface Props {
  upcomingPayroll: UpcomingPayroll
  isNext: boolean
}

const PayrollCard = ({upcomingPayroll, isNext}: Props) => {
  const styles = useStyles()

  const getCardBackgroundColor = () => {
    if (upcomingPayroll.payrollFileOverdue || upcomingPayroll.validationErrors?.length > 0) {
      return Colors.yuan_100
    }

    if (upcomingPayroll.payrollFileDue) {
      return Colors.yen_300
    }

    if (upcomingPayroll.payrollFileSubmitted && (!upcomingPayroll.validationErrors || upcomingPayroll.validationErrors.length === 0)) {
      return Colors.euro_50
    }

    return Colors.grayBackgroundApp
  }

  const renderContent = () => {
    if (upcomingPayroll.validationErrors?.length > 0) {
      return (
        <ValidationErrorContent upcomingPayroll={upcomingPayroll}/>
      )
    } else if (upcomingPayroll.payrollFileOverdue) {
      return (
        <OverdueContent upcomingPayroll={upcomingPayroll}/>
      )
    } else if (upcomingPayroll.payrollFileDue) {
      return (
        <DueContent upcomingPayroll={upcomingPayroll}/>
      )
    } else if (upcomingPayroll.payrollFileSubmitted && (!upcomingPayroll.validationErrors || upcomingPayroll.validationErrors.length === 0)) {
      return (
        <SuccessContent upcomingPayroll={upcomingPayroll}/>
      )
    } else if (isNext) {
      return (
        <UpcomingContent upcomingPayroll={upcomingPayroll}/>
      )
    } else {
      return (
        <FutureContent upcomingPayroll={upcomingPayroll}/>
      )
    }
  }

  return (
    <Card className={styles.container} style={{backgroundColor: getCardBackgroundColor()}}>
      <div className={styles.statusIconContainer}>
        <StatusIcon upcomingPayroll={upcomingPayroll}/>
      </div>
      {renderContent()}
    </Card>
  )
}

export default PayrollCard

const useStyles = createUseStyles({
  container: {
    position: 'relative',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    minWidth: 400
  },
  statusIconContainer: {
    position: 'absolute',
    right: 20,
    top: 15
  }
})
